import Dashboard from './template/Dashboard';

function App() {
  return (
    <Dashboard />
  );
}

export default App;
